export default __webpack_public_path__ + "static/media/app-store-promo.10b68b9a.mov";